module.exports = __webpack_public_path__ + "img/business.da6d768.svg";